import React from 'react';
import styled from '@emotion/styled';
import { halfSpacing } from 'ui/theme/themeConstants';
import { bluePlanetTheme } from 'ui/theme';
import { KpiNumericInput } from '../KpiNumericInput';

const MonthRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${halfSpacing} 0;
  border-bottom: 1px solid ${bluePlanetTheme.palette.divider};

  &:last-child {
    border-bottom: none;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${halfSpacing};
  flex: 1;
  justify-content: flex-end;
  min-width: 0; /* Allow shrinking below content size */
`;

const MonthLabel = styled.div`
  min-width: 9.375rem;
  font-size: ${bluePlanetTheme.typography.body1.fontSize};
  font-weight: ${bluePlanetTheme.typography.fontWeightMedium};
  color: ${bluePlanetTheme.bluePlanetPalette.grey.dark};

  ${bluePlanetTheme.breakpoints.down('sm')} {
    min-width: 8rem;
    flex-shrink: 0;
  }
`;

const UnitLabel = styled.span`
  min-width: 2.5rem;
  font-size: ${bluePlanetTheme.typography.body1.fontSize};
  color: ${bluePlanetTheme.bluePlanetPalette.grey.dark};
  flex-shrink: 0;

  ${bluePlanetTheme.breakpoints.down('sm')} {
    min-width: 1.5rem;
  }
`;

interface MonthInputRowProps {
  month: string;
  value?: number;
  unitOfMeasure?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  inputRef: (ref: HTMLInputElement | null) => void;
  autoFocus?: boolean;
}

export default function MonthInputRow({
  month,
  value,
  unitOfMeasure,
  onChange,
  onBlur,
  onKeyDown,
  inputRef,
  autoFocus,
}: MonthInputRowProps) {
  return (
    <MonthRow>
      <MonthLabel>{month}</MonthLabel>
      <InputContainer>
        <KpiNumericInput
          autoFocus={autoFocus}
          getInputRef={inputRef}
          value={value}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
          onChange={(e: any) => onChange(e.target.value.replace(/\s/g, ''))}
        />
        {unitOfMeasure && <UnitLabel>{unitOfMeasure}</UnitLabel>}
      </InputContainer>
    </MonthRow>
  );
}
